import { Popper as MuiPopper, styled } from "@mui/material";
import { actionBarName } from "../classes.js";
const Popper = styled(MuiPopper, {
  name: actionBarName,
  overridesResolver: (_props, styles) => styles.popper,
  slot: "Popper"
})(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1
}));
export {
  Popper
};
//# sourceMappingURL=Popper.js.map
